document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const heroSection = document.querySelector("#main");
  const aboutSection = document.querySelector("#about");
  const specialtySection = document.querySelector("#specialty");
  const medalion = document.querySelector("#logo-start");

  const headerHeight = 200;

  const mm = gsap.matchMedia();
  let isMobile = false;

  mm.add("(min-width: 992px)", () => {
    isMobile = false;

    if (!heroSection || !aboutSection || !specialtySection) return;
    const tlShrink = gsap.timeline({
      scrollTrigger: {
        trigger: aboutSection,
        start: "top bottom",
        end: `top ${headerHeight}px`,
        scrub: true,
      },
    });

    tlShrink.to(heroSection, { height: "15vh", ease: "none" }, 0);
    tlShrink.to(medalion, { yPercent: 30, ease: "none" }, 0);
    tlShrink.to(".hero .layer-bg", { ease: "none" }, 0);
    tlShrink.to(".hero .layer-soldier-L", { yPercent: 55, ease: "none" }, 0);
    tlShrink.to(".hero .layer-soldier-M", { yPercent: 60, ease: "none" }, 0);
    tlShrink.to(".hero .layer-soldier-R", { yPercent: 55, ease: "none" }, 0);
    tlShrink.to(".hero .layer-footer", { yPercent: 20, ease: "none" }, 0);
    tlShrink.to(".hero .hero__title", { yPercent: -200, ease: "none" }, 0);

    ScrollTrigger.create({
      trigger: specialtySection,
      start: `top ${headerHeight}px`,
      onEnter: () => {
        heroSection.style.position = "absolute";
        const topPos = specialtySection.offsetTop - headerHeight;
        heroSection.style.top = topPos + "px";
      },
      onLeaveBack: () => {
        heroSection.style.position = "fixed";
        heroSection.style.top = "0";
      },
    });
  });

  mm.add("(max-width: 991px)", () => {
    isMobile = true; 
  });

  const container3D = document.getElementById("webgl-container");
  const logoWrapper = document.getElementById("logo-start");

  if (!container3D || !logoWrapper) return;

  const scene = new THREE.Scene();
  const width = logoWrapper.clientWidth;
  const height = logoWrapper.clientHeight || 350;

  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1000);
  camera.position.z = 4;

  const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
  renderer.setSize(width, height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 2.5;

  const ambientLight = new THREE.AmbientLight(0xffffff, 2.5);
  scene.add(ambientLight);
  const frontLight = new THREE.DirectionalLight(0xffffff, 4.0);
  frontLight.position.set(0, 2, 5);
  scene.add(frontLight);
  const rimLight = new THREE.DirectionalLight(0xffffff, 3.0);
  rimLight.position.set(5, 5, -5);
  scene.add(rimLight);

  container3D.appendChild(renderer.domElement);

  const modelPath = container3D.getAttribute("data-model");
  const hdrPath = container3D.getAttribute("data-hdr");

  // Прелоадер
  const manager = new THREE.LoadingManager();
  const preloader = document.getElementById("preloader");
  const loadingText = document.getElementById("loading-text");

  manager.onProgress = function (url, itemsLoaded, itemsTotal) {
    const progress = Math.floor((itemsLoaded / itemsTotal) * 100);
    if (loadingText) {
      loadingText.innerText = progress + "%";
    }
  };

  manager.onLoad = function () {
    if (preloader) {
      const tlPreloader = gsap.timeline({
        onComplete: () => {
          preloader.style.display = "none";
        },
      });
      tlPreloader
        .to({}, { duration: 0.3 })
        .to(loadingText, {
          scale: 4,
          opacity: 0,
          duration: 0.5,
          ease: "power4.in",
        })
        .to(
          preloader,
          {
            yPercent: -100,
            duration: 1,
            ease: "expo.inOut",
          },
          "-=0.2",
        );
    }
  };

  let idleWrapper;
  let mixer;
  let fallbackModel;

  new THREE.RGBELoader(manager).load(hdrPath, function (texture) {
    texture.mapping = THREE.EquirectangularReflectionMapping;
    scene.environment = texture;

    const loader = new THREE.GLTFLoader(manager);

    loader.load(modelPath, (gltf) => {
      const model = gltf.scene;
      fallbackModel = model;

      model.scale.set(1, 1, 1);
      model.position.set(0, 0, 0);
      model.rotation.y = Math.PI / 2.1;

      idleWrapper = new THREE.Group();
      idleWrapper.add(model);
      scene.add(idleWrapper);

      if (gltf.animations && gltf.animations.length > 0) {
        mixer = new THREE.AnimationMixer(model);
        const action = mixer.clipAction(gltf.animations[0]);
        action.play();
        const clipDuration = action.getClip().duration;

        mm.add("(min-width: 992px)", () => {
          gsap.to(
            {},
            {
              scrollTrigger: {
                trigger: "#about",
                start: "top bottom",
                end: "top 200px",
                scrub: 2,
                onUpdate: (self) => {
                  const speedFactor = 0.8;
                  mixer.setTime(self.progress * (clipDuration * speedFactor));
                },
              },
            },
          );
        });
      } else {

        mm.add("(min-width: 992px)", () => {
          gsap.to(model.rotation, {
            y: Math.PI / 2.1 + Math.PI * 2,
            ease: "none",
            scrollTrigger: {
              trigger: "#about",
              start: "top bottom",
              end: "top 200px",
              scrub: true,
            },
          });
        });
      }
    });
  });

  let previousTime = 0;

  function animate(currentTime) {
    requestAnimationFrame(animate);
    const time = currentTime * 0.001 || 0;
    const delta = time - previousTime;
    previousTime = time;

    if (idleWrapper) {
      idleWrapper.position.y = Math.sin(time * 1.5) * 0.01;
      idleWrapper.rotation.z = Math.cos(time * 1.2) * 0.01;
      idleWrapper.rotation.x = Math.sin(time * 1.0) * 0.01;
    }

    if (isMobile) {
      if (mixer) {
        mixer.update(delta); 
      } else if (fallbackModel) {
        fallbackModel.rotation.y += delta * 0.5; 
      }
    }

    renderer.render(scene, camera);
  }

  animate();

  window.addEventListener("resize", () => {
    const newWidth = logoWrapper.clientWidth;
    const newHeight = logoWrapper.clientHeight || 350;

    camera.aspect = newWidth / newHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(newWidth, newHeight);
  });
});
